const Quote = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M2.66602 2.66699V3.60033C2.66602 5.84054 2.66602 6.96064 3.10199 7.81629C3.48548 8.56894 4.09741 9.18086 4.85005 9.56435C5.7057 10.0003 6.82581 10.0003 9.06602 10.0003H13.3327M13.3327 10.0003L9.99935 6.66699M13.3327 10.0003L9.99935 13.3337"
      stroke="#535862"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Quote;
